import styles from "./Layout.module.scss";
import { Layout } from "antd";
import greenwiselogo from '../../globals/images/Layout/greenwiselogo.png';

const LayoutComponent = (props: any) => {
  const { Header, Footer, Content } = Layout;
  const actualDate = new Date();
  return (
    <div className={styles["layout-container"]}>
      <Layout >
        <Content>
          {props.children}
        </Content>
        {/* <Footer>
          <div className={styles["footer-text"]}>
            <p>Todos los derechos reservados {moment(actualDate).format("YYYY")}. Desarrollado por BluelightCoding</p>
          </div>
        </Footer> */}
      </Layout>
    </div>
  );
}


export default LayoutComponent;